<span *ngIf="_size < 4" class="fal fa-fw" [ngClass]="_class" aria-hidden="true"></span>
<span *ngIf="_size === 4" class="fa-layers fa-fw">
    <i class="fal fa-fw grouped-icon-1" [ngClass]="_class" aria-hidden="true"></i>
    <i class="fal fa-fw grouped-icon-2" [ngClass]="_class" aria-hidden="true"></i>
    <i class="fal fa-fw grouped-icon-3" [ngClass]="_class" aria-hidden="true"></i>
</span>